<mat-form-field appearance="fill">
  <mat-label>Select a carrier</mat-label>
  <mat-select [(value)]="selectedCarrierId" (selectionChange)="setCarrierID($event.value)">
    <mat-option *ngFor="let carrier of carriers; trackBy: trackById" [value]="carrier.id">
      {{ carrier.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
